import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import classNames from 'classnames';
import { get } from 'lodash';
import { Link } from 'react-router';
import { COLLECTION_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import { helperGetBaseUrlSlug } from 'helpers/RouteHelper';
import Image from 'components/Tile/components/Image';
import theme from './style.css';

const CollectionLinkTile = props => {
  const { breakpoint, item } = props;
  if (!item) return null;

  const { '@type': type, images, headline, link: linkData } = item;
  const image = get(images, 'seriesDetail', null);
  const url = get(linkData, '0.url');
  const baseUrlSlug = helperGetBaseUrlSlug();
  const link = `${baseUrlSlug}${url}`;
  const tileClasses = [theme.tile];
  const titleClasses = [theme.title];
  if (type === 'seeMore') tileClasses.push(theme.seeMore);
  if (!image) titleClasses.push(theme.withSpacer);

  return (
    <div className={classNames(tileClasses)}>
      <div className={theme.imageContainer}>
        <Link to={link}>
          <LazyLoad offset={100} debounce={false} throttle={350} unmountIfInvisible once>
            <Image
              breakpoint={breakpoint}
              imageType={COLLECTION_THUMBNAIL_IMAGE}
              src={image}
              theme={theme}
            >
              <div className={classNames(titleClasses)}>{headline}</div>
            </Image>
          </LazyLoad>
        </Link>
      </div>
    </div>
  );
};

export default CollectionLinkTile;

CollectionLinkTile.defaultProps = {
  item: null,
};

CollectionLinkTile.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
};
